var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.form)?_c('vp-form',{staticClass:"form form--service",attrs:{"saving":_vm.saving},on:{"save":_vm.onSave},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }